<template>
  <div class="about">
    <help></help>
  </div>
</template>
<script>
import help from '@/components/tagtool/help'
export default {
  name: 'about',
  components: {
    help
  }
}
</script>
